// extracted by mini-css-extract-plugin
export default {"container":"Specs_container__5bXZn","row":"Specs_row__BpBUx","label":"Specs_label__FjLcr","value":"Specs_value__jpQxi"};